import BasePagination from "./BasePagination";
export default BasePagination;